module.exports = __webpack_public_path__ + "img/crying_face.125dc24d.gif";